export default __webpack_public_path__ + "static/media/ic-tr.8dc38975.svg";